const STORAGE_KEY = 'sessionInfo';


export const getSessionInfo = () => {
  const sessionInfo = sessionStorage.getItem(STORAGE_KEY);
  return sessionInfo ? JSON.parse(sessionInfo) : {};
};

export const storeSessionInfo = (sessionInfo) => {
  sessionStorage.setItem(STORAGE_KEY, sessionInfo? JSON.stringify(sessionInfo): null);
};

export const resetSessionInfo = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
